export const formatJson = (jsonString) => {
  try {
    const jsonObject = JSON.parse(jsonString);
    return JSON.stringify(jsonObject, null, 2);
  } catch (error) {
    console.error('Failed to parse JSON:', error);
    return jsonString;
  }
};
